/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule5_ActionInputs */

const tr_landing_pricerules_mock_rule5_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onay beklemeden otomatik uygula`)
};

const en_landing_pricerules_mock_rule5_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply automatically without approval`)
};

const de_landing_pricerules_mock_rule5_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Freigabe automatisch anwenden`)
};

const ru_landing_pricerules_mock_rule5_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применять автоматически без подтверждения`)
};

/**
* | output |
* | --- |
* | "Apply automatically without approval" |
*
* @param {Landing_Pricerules_Mock_Rule5_ActionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule5_action = /** @type {((inputs?: Landing_Pricerules_Mock_Rule5_ActionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule5_ActionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule5_action(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule5_action(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule5_action(inputs)
	return tr_landing_pricerules_mock_rule5_action(inputs)
});